export enum TaskListModeEnum {
  Inbox = 'inbox',
  Pushbox = 'pushbox',
  Search = 'search',
}
